import { Component, Input, OnInit} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { UpdatePasswordDocenteRequest } from 'src/app/content/docente/requests/update-password-docente-request';
import { DocenteService } from 'src/app/content/docente/services/docente.service';
import { UpdatePasswordEgresadoRequest } from 'src/app/content/egresado/requests/update-password-egr-request';
import { EgresadoService } from 'src/app/content/egresado/services/egresado.service';
import { AuthUser } from 'src/app/login/administrador/AuthUser';
import { graduatedLoginResponse } from 'src/app/login/models/entities/graduatedLoginResponse';
import { UserRole } from 'src/app/_models/userEnum';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.css']
})
export class ChangePasswordModalComponent implements OnInit {
  @Input() typeNumber: number = 0;

  gradUser;
  profUser;
  updatePasswordForm : FormGroup;
  constructor(public activeModal: NgbActiveModal,
              private graduadoService:EgresadoService,
              private docenteService : DocenteService,
              private fb: FormBuilder,
              private toastr : ToastrService,
              private authService : AuthService
              ){}

    ngOnInit() {
    this.initUpdateForm();
    if(this.typeNumber && this.typeNumber==1)
    {
      this.gradUser= this.authService.getGraduated() as graduatedLoginResponse;
      return;
    }
    if(this.typeNumber && this.typeNumber==2)
    {
      this.profUser= this.authService.getProf();
      return;
    }
    this.activeModal.close();
  }

  initUpdateForm() {
    this.updatePasswordForm = this.fb.group({
      password: new FormControl('', [Validators.required,
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,50}$/)]),
    });
  }

  get f() {
    return this.updatePasswordForm.controls;
  }

  dismiss() {
    this.disablePasswordStatus();
    this.activeModal.close();
  }

  async tryUpdate()
  {
    if(this.updatePasswordForm.invalid)
    {
      this.toastr.warning('Debe ser una contraseña válida, (6 carácteres mínimo, mayúscula, minúscula y número).', 'Advertencia', {
        tapToDismiss: false
      });
      return;
    }
    if(this.typeNumber==1)//1 = graduado form
    {
      if(await this.updateGraduatedPassword())
        this.dismiss();
    }
    if(this.typeNumber==2)//2 = docente form
    {
      if(await this.updateDocentePassword())
        this.dismiss();
    }
  }

  async updateGraduatedPassword() : Promise<boolean>
  {
    const currentUser = this.authService.getUser() as AuthUser;
      if(currentUser.role===UserRole.Graduated)
      {
        if(this.gradUser)
        {
          try
          {
            let data : UpdatePasswordEgresadoRequest = {} as UpdatePasswordEgresadoRequest;
            data.idUsuario=this.gradUser.idUsuario;
            data.password=this.f.password.value; 
            const res = await firstValueFrom(this.graduadoService.actualizarPassword(data));
              if(!res.success)
              {
                if(res.equalPassword)
                {
                  this.toastr.error('La contraseña no puede ser la misma.', 'Error', {
                    progressBar: true,
                    progressAnimation: 'increasing',
                    tapToDismiss: false
                  });
                  return false;
                }
                return false;
              }
              this.toastr.success('Contraseña actualizada.', 'Correcto!', {
                progressBar: true,
                progressAnimation: 'increasing',
                tapToDismiss: false
              });
              return true;
          }
          catch
          {
            this.toastr.error('Hubo un fallo en el servidor, intentalo después.', 'Error', {
              progressBar: true,
              progressAnimation: 'increasing',
              tapToDismiss: false
            });
            return true;
          }
        }
      }
  }

  async updateDocentePassword() : Promise<boolean>
  {
    const currentUser = this.authService.getUser() as AuthUser;
      if(currentUser.role===UserRole.Professor)
      {
        if(this.profUser)
        {
          try
          {
            let data : UpdatePasswordDocenteRequest = {} as UpdatePasswordDocenteRequest;
            data.idUsuario=this.profUser.idUsuario;
            data.password=this.f.password.value; 
            const res = await firstValueFrom(this.docenteService.updatePassword(data));
              if(!res.success)
              {
                if(res.equalPassword)
                {
                  this.toastr.error('La contraseña no puede ser la misma.', 'Error', {
                    progressBar: true,
                    progressAnimation: 'increasing',
                    tapToDismiss: false
                  });
                  return false;
                }
                return false;
              }
              this.toastr.success('Contraseña actualizada.', 'Correcto!', {
                progressBar: true,
                progressAnimation: 'increasing',
                tapToDismiss: false
              });
              return true;
          }
          catch
          {
            this.toastr.error('Hubo un fallo en el servidor, intentalo después.', 'Error', {
              progressBar: true,
              progressAnimation: 'increasing',
              tapToDismiss: false
            });
            return true;
          }
        }
      }
  }


  disablePasswordStatus()
  {
    if(this.typeNumber==1)
    {
      this.gradUser.statusPassword=false;
      this.authService.saveGraduado(this.gradUser);
    }
    if(this.typeNumber==2)
    {
      this.profUser.statusPassword=false;
      this.authService.saveProf(this.profUser);
    }
  }

}
